import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "imports.icon",
  "use": "imports.icon-usage",
  "viewBox": "-13073.266 -4659.68 15.801 28.405",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-13073.266 -4659.68 15.801 28.405\" id=\"imports.icon\"><defs><style>#imports.icon .cls-1{fill:#0063b0}</style></defs><g id=\"imports.icon_Group_1738\" data-name=\"Group 1738\" transform=\"translate(-13126 -5147)\"><path id=\"imports.icon_Path_756\" data-name=\"Path 756\" class=\"cls-1\" d=\"M185.291,117.509h-5.247V105.2h-5.3v12.309H169.5l7.9,13.683Z\" transform=\"translate(-116.766 382.12)\" /><path id=\"imports.icon_Rectangle_3183\" data-name=\"Rectangle 3183\" class=\"cls-1\" transform=\"translate(52.734 514.725)\" d=\"M0 0H15.801V1H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/imports.icon.svg
// module id = qAPs
// module chunks = 13